class SwiperCardWithText extends HTMLElement {
    constructor() {
        super();
        this._swiper = null;
        this.swiperEl = this.querySelector('.swiper')
    }

    connectedCallback() {
        this._init();
    }

    disconnectedCallback() {
        if (this._swiper) {
            this._swiper.destroy(true, true);
            this._swiper = null;
        }
    }

    _init() {
        if (this.swiperEl) {
            this._swiper = new Swiper(this.swiperEl, {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next'),
                    prevEl: this.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: true,
                },
            });
        }
    }
}

customElements.define('swiper-card-with-text', SwiperCardWithText);